<template>
  <div label="批次报告" name="batchReport">
    <div id="pdfDom">
      <div class="plLoadingLogo" style="text-align:center;font-size:30px;font-weight:bold" v-if="!pdfJudge">
        <br/>
        <br/>
          <img src="/static/imgs/fengyan/logomini.png" width="50" height="50"/>
          <span style="position:relative;top:-10px">作业报告</span>
      </div>
    <div class="padding15-tb">
      <el-row>
        <el-col :span="2"><span style="font-size: 16px;position:relative;top:4px;">批次号：</span></el-col>
        <el-col :span="6" style="position:relative;left:-3%;width: 23%;">
          <selector v-if="batchNo" v-model="batchNo" single filterable :remote="searchBatchList" :options="options"></selector>
        </el-col>
        <el-col :span="6" :offset="10">
          <el-button type="primary" size="small" style="float:right " @click="importPDF" v-if="pdfJudge">导出PDF</el-button>
          <div style="float:right " v-if="!pdfJudge">生成时间：{{startTime}}&nbsp;</div>
        </el-col>
      </el-row>
      <br/>
      <br/>
      <div class="index-section m-t-24">
        <p style="font-size: 16px;font-weight:bold;font-family:黑体"><i class="fa fa-dashboard">&nbsp;作业汇总:</i></p><br/>
        <el-row :gutter="24">
          <el-col :span="11">
            <p style="position:relative;left:75%;font-size:90%;">同比上月</p>
            <el-row :gutter="12">
              <el-col :span="19">
                <span>案件回款率:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><el-progress style="width:70%;display: inline-block;" :text-inside="true" :stroke-width="22" :percentage="caseCollectionRat" color="E6A23C"></el-progress><br/><br/>
                <span>本人可联率:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><el-progress style="width:70%;display: inline-block;" :text-inside="true" :stroke-width="22" :percentage="personalContactRat" color="#8e71c7"></el-progress><br/><br/>
                <span>联系人可联率:&nbsp;</span><el-progress style="width:70%;display: inline-block;" :text-inside="true" :stroke-width="22" :percentage="contactRat" color="#8e71c7"></el-progress><br/><br/>
                <span>案件回复率:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><el-progress style="width:70%;display: inline-block;" :text-inside="true" :stroke-width="22" :percentage="caseResponseRat" color="#1874CD"></el-progress>
              </el-col>
              <el-col :span="4">
                <span style="position:relative;top: 3px;left:-40%" v-if="caseCollectionCompared.substring(0,1) === '-'"><i class="el-icon-caret-bottom" style="font-size:100%;color: #52c41a;">{{caseCollectionCompared.substring(1,caseCollectionCompared.length)}}%</i></span>
                <span style="position:relative;top: 3px;left:-35%" v-else-if="caseCollectionCompared === '0'">-&nbsp;&nbsp;-</span>
                <span style="position:relative;top: 3px;left:-40%" v-else-if="caseCollectionCompared.substring(0,1) !== '-'"><i class="el-icon-caret-top" style="font-size:100%;color: #f5222d;">{{caseCollectionCompared}}%</i></span>
                <br/><br/>
                <span style="position:relative;top: 5px;left:-40%" v-if="personalContactCompared.substring(0,1) === '-'"><i class="el-icon-caret-bottom" style="font-size:100%;color: #52c41a;">{{personalContactCompared.substring(1, personalContactCompared.length)}}%</i></span>
                <span style="position:relative;top: 5px;left:-35%" v-else-if="personalContactCompared === '0'">-&nbsp;&nbsp;-</span>
                <span style="position:relative;top: 5px;left:-40%" v-else-if="personalContactCompared.substring(0,1) !== '-'"><i class="el-icon-caret-top" style="font-size:100%;color: #f5222d;">{{personalContactCompared}}%</i></span>
                <br/><br/>
                <span style="position:relative;top: 5px;left:-40%" v-if="contactCompared.substring(0,1) === '-'"><i class="el-icon-caret-bottom" style="font-size:100%;color: #52c41a;">{{contactCompared.substring(1, contactCompared.length)}}%</i></span>
                <span style="position:relative;top: 5px;left:-35%" v-else-if="contactCompared === '0'">-&nbsp;&nbsp;-</span>
                <span style="position:relative;top: 5px;left:-40%" v-else-if="contactCompared.substring(0,1) !== '-'"><i class="el-icon-caret-top" style="font-size:100%;color: #f5222d;">{{contactCompared}}%</i></span>
                <br/><br/>
                <span style="position:relative;top: 8px;left:-40%" v-if="caseResponseCompared.substring(0,1) === '-'"><i class="el-icon-caret-bottom" style="font-size:100%;color: #52c41a;">{{caseResponseCompared.substring(1, caseResponseCompared.length)}}%</i></span>
                <span style="position:relative;top: 8px;left:-35%" v-else-if="caseResponseCompared === '0'">-&nbsp;&nbsp;-</span>
                <span style="position:relative;top: 8px;left:-40%" v-else-if="caseResponseCompared.substring(0,1) !== '-'"><i class="el-icon-caret-top" style="font-size:100%;color: #f5222d;">{{caseResponseCompared}}%</i></span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <br/>
            <el-card shadow="never" style="background:#33CC99;">
              <br/>
              <div style="font-size: 270%;text-align:center; float:left">
                <i class="fa fa-commenting-o"></i>&nbsp;&nbsp;
              </div>
              <div style="font-size:180%;font-weight:bold;">{{msgSendCount}}<span style="font-size:50%;font-weight:normal;">&nbsp;{{msgAverag}}/件&nbsp;</span></div><div style="float:right;position:relative;top:-22px;font-size:60%;">短信发送数</div>
              <div><span style="font-size:180%;font-weight:bold">{{msgRounds}}</span>&nbsp;</div><div style="float:right;position:relative;top:-25px;font-size:70%;">平均交互轮次</div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <br/>
            <el-card shadow="never" style="background:#63B8FF;">
              <br/>
              <div style="font-size: 270%;text-align:center; float:left">
                <i class="fa fa-phone"></i>&nbsp;&nbsp;
              </div>
              <div style="font-size:180%;font-weight:bold">{{ivrSendCount}}<span style="font-size:50%;">&nbsp;{{ivrAverag}}/件&nbsp;</span></div><div style="float:right;position:relative;top:-22px;font-size:60%;">语音发送数</div>
              <div><span style="font-size:180%;font-weight:bold">{{answerRate}}%</span></div><div style="float:right;position:relative;top:-25px;font-size:70%;">接听率</div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div class="index-section m-t-24">
        <span style="font-size: 16px;font-weight:bold;"><i class="fa fa-list">&nbsp;案件信息:</i></span><br/>
        <el-table
          :data="caseDataList"
          size="small"
          border
          style="width: 100%; margin-top: 20px">
          <el-table-column
            prop="importTime"
            label="导入日期"
            align="center">
          </el-table-column>
          <el-table-column
            prop="caseCount"
            label="案件数"
            align="center">
          </el-table-column>
          <el-table-column
            prop="casePCount"
            :render-header="renderHeadercaseP"
            label="子案件数"
            align="center">
          </el-table-column>
          <el-table-column
            prop="contactCount"
            label="联系人数"
            align="center">
            <template slot-scope="scope">
              <el-tooltip placement="right" effect="light">
                <el-table
                  slot="content"
                  :data="contactList"
                  size="small"
                  border
                  style="width: 100%;">
                  <el-table-column
                    prop="type"
                    label="对象"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="contactCount"
                    label="人数"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="proportion"
                    label="占比"
                    align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.proportion}}%</span>
                    </template>
                  </el-table-column>
                </el-table>
                <span>{{scope.row.contactCount}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="averageOverdueDates"
            label="平均逾期天数"
            align="center">
            <template slot-scope="scope">
              <el-tooltip placement="right" effect="light">
                <el-table
                  slot="content"
                  :data="overdueDatesList"
                  size="small"
                  border
                  style="width: 100%;">
                  <el-table-column
                    prop="overdueDate"
                    label="逾期天数"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="caseCount"
                    label="案件数"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    prop="proportion"
                    label="占比"
                    align="center">
                    <template slot-scope="scope">
                      <span>{{scope.row.proportion}}%</span>
                    </template>
                  </el-table-column>
                </el-table>
                <span>{{scope.row.averageOverdueDates}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="averageAmount"
            label="件均金额"
            align="center">
          </el-table-column>
          <el-table-column
            prop="alScore"
            label="AI评分"
            align="center">
          </el-table-column>
        </el-table>
      </div>

      <div class="index-section m-t-24">
        <span style="font-size: 16px;font-weight:bold;"><i class="fa fa-gear">&nbsp;作业设置:</i></span><br/>
        <el-table
          :data="collectionSetList"
          size="small"
          border
          style="width: 100%; margin-top: 20px">
          <el-table-column
            prop="groupName"
            label="策略组"
            align="center">
          </el-table-column>
          <el-table-column
            prop="sendPercentage"
            label="发送比例"
            align="center">
          </el-table-column>
          <el-table-column
            prop="planDaysPage"
            label="作业天数"
            align="center">
          </el-table-column>
          <el-table-column
            prop="collectSendObject"
            label="作业对象"
            align="center">
          </el-table-column>
          <el-table-column
            prop="planDiscount"
            label="最高减免"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.planDiscount}}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="averageFollowMsgPage"
            label="日均跟进短信"
            :render-header="renderHeaderMsg"
            align="center">
          </el-table-column>
          <el-table-column
            prop="averageFollowIvrPage"
            label="日均跟进语音"
            :render-header="renderHeaderIvr"
            align="center">
          </el-table-column>
        </el-table>
      </div>
      </div>
      <div class="index-section m-t-24">
        <span style="font-size: 16px;font-weight:bold;"><i class="fa fa-line-chart">&nbsp;作业周期:</i></span>
        <el-select v-model="group" filterable placeholder="请选择" style="width: 20%;" @change="changeCollectionCycleCondition" v-show="groupHidden">
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.groupName"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="fr send-options">
          <el-radio-group v-model="type" @change="changeCollectionCycleCondition">
            <el-radio-button label="hours">小时</el-radio-button>
            <el-radio-button label="day">日</el-radio-button>
          </el-radio-group>
        </div>
        <br/>
        <br/>
        <div v-if="this.chartData.rows.length !== 0">
          <ve-histogram :data="chartData" :settings="chartSettings" v-loading="loading"></ve-histogram>
        </div>
        <div v-else>
          <p style="text-align: center;">暂无数据</p>
        </div>
      </div>

      <div class="index-section m-t-24">
        <el-row :gutter="24">
          <el-col :span="8">
            <span style="font-size: 16px;font-weight:bold;"><i class="fa fa-user">&nbsp;本人联系状态:</i></span>
            <el-table
              :data="personalContactStatusList"
              size="small"
              @row-click="toCaseList"
              border
              style="width: 100%; margin-top: 20px">
              <el-table-column
                prop="personalContactStatus"
                label="本人联系状态"
                align="center">
              </el-table-column>
              <el-table-column
                prop="proportion"
                label="占比"
                align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.proportion}}%</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="comparedLastMonthPage"
                label="同比上月"
                align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.comparedLastMonthPage.substring(0,1) === '-'"><i class="el-icon-caret-bottom" style="font-size:100%;color: #52c41a;">{{scope.row.comparedLastMonthPage.substring(1,scope.row.comparedLastMonthPage.length)}}%</i></span>
                  <span v-else-if="scope.row.comparedLastMonthPage === '0'">-&nbsp;&nbsp;-</span>
                  <span v-else-if="scope.row.comparedLastMonthPage.substring(0,1) !== '-'"><i class="el-icon-caret-top" style="font-size:100%;color: #f5222d;">{{scope.row.comparedLastMonthPage}}%</i></span>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="16">
            <span style="font-size: 16px;font-weight:bold;"><i class="fa fa-send-o">&nbsp;案件触达状态:</i></span>
            <br/>
            <br/>
            <table class="tableM">
              <thead>
                <td style="padding: 0; width: 200px;">
                  <canvas ref="cvs" width="200" height="50" style="margin-bottom: -5px;"></canvas>
                </td>
                <td>未发送</td>
                <td>未接听</td>
                <td>已接听</td>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align:center">未发送</td>
                  <td style="background:#FF7744;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgAndIvrNosend}}({{caseTouchOfStatus.msgAndIvrNosendScale}}%)</td>
                  <td style="background: #FFA488;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgNosendAndIvrNoResponse}}({{caseTouchOfStatus.msgNosendAndIvrNoResponseScale}}%)</td>
                  <td style="background: #66CDAA;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgNosendAndIvrAnswer}}({{caseTouchOfStatus.msgNosendAndIvrAnswerScale}}%)</td>
                </tr>
                <tr>
                  <td style="text-align:center">未回复</td>
                  <td style="background: #FFA488;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgNoReplyAndIvrNosend}}({{caseTouchOfStatus.msgNoReplyAndIvrNosendScale}}%)</td>
                  <td style="background: #FFDD55;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgNoReplyAndIvrNoResponse}}({{caseTouchOfStatus.msgNoReplyAndIvrNoResponseScale}}%)</td>
                  <td style="background: #00AA55;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgNoReplyAndIvrAnswer}}({{caseTouchOfStatus.msgNoReplyAndIvrAnswerScale}}%)</td>
                </tr>
                <tr>
                  <td style="text-align:center">已回复</td>
                  <td style="background: #66CDAA;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgReplyAndIvrNosend}}({{caseTouchOfStatus.msgReplyAndIvrNosendScale}}%)</td>
                  <td style="background: #00AA55;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgReplyAndIvrNoResponse}}({{caseTouchOfStatus.msgReplyAndIvrNoResponseScale}}%)</td>
                  <td style="background: #227700;font-weight:bold;color:#000000;">{{caseTouchOfStatus.msgReplyAndIvrAnswer}}({{caseTouchOfStatus.msgReplyAndIvrAnswerScale}}%)</td>
                </tr>
              </tbody>
            </table>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import VeLine from 'v-charts/lib/line.common';
import VeRing from 'v-charts/lib/ring.common';
import VeHistogram from 'v-charts/lib/histogram.common';
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
import Selector from '../../../../components/Select';

export default {
  data() {
    this.chartSettings = {
      stack: { '语音': ['语音发送数', '语音接听数'] },
      axisSite: { right: ['累计回款率', '累计回复率'] },
      yAxisType: ['', 'percent'],
      showLine: ['累计回款率', '累计回复率']
    };
    return {
      batchNo: '',
      batchNoList: [],
      caseDataList: [],
      collectionSetList: [],
      personalContactStatusList: [],
      caseTouchOfStatusList: [],
      caseTouchOfStatusMsgList: [{ noSend: 1, noResponse: 2, alreadyResponse: 3 }],
      caseTouchOfStatusIvrList: [],
      type: 'hours',
      group: '',
      groupList: [],
      chartData: {
        columns: ['日期', '短信发送数', '语音发送数', '语音接听数', '累计回款率', '累计回复率'],
        rows: []
      },
      loading: false,
      messageType: 'msg',
      caseCollectionRat: 0,
      caseCollectionCompared: '0',
      personalContactRat: 0,
      personalContactCompared: '0',
      contactRat: 0,
      contactCompared: '0',
      caseResponseRat: 0,
      caseResponseCompared: '0',

      msgSendCount: 0,
      msgAverag: 0,
      msgRounds: 0,
      ivrSendCount: 0,
      ivrAverag: 0,
      answerRate: 0,
      caseTouchOfStatus: {
        msgAndIvrNosend: 0,
        msgNosendAndIvrNoResponse: 0,
        msgNosendAndIvrAnswer: 0,
        msgNoReplyAndIvrNosend: 0,
        msgNoReplyAndIvrNoResponse: 0,
        msgNoReplyAndIvrAnswer: 0,
        msgReplyAndIvrNosend: 0,
        msgReplyAndIvrNoResponse: 0,
        msgReplyAndIvrAnswer: 0,
        msgAndIvrNosendScale: 0,
        msgNosendAndIvrNoResponseScale: 0,
        msgNosendAndIvrAnswerScale: 0,
        msgNoReplyAndIvrNosendScale: 0,
        msgNoReplyAndIvrNoResponseScale: 0,
        msgNoReplyAndIvrAnswerScale: 0,
        msgReplyAndIvrNosendScale: 0,
        msgReplyAndIvrNoResponseScale: 0,
        msgReplyAndIvrAnswerScale: 0
      },
      pdfJudge: true,
      startTime: '',
      groupHidden: false,
      overdueDatesList: [],
      contactList: []
    };
  },
  computed: {
    options() {
      return this.batchNoList.map((item) => {
        item.title = item.companyName.length > 6 ? `${item.companyName.substring(0, 6)}...(${item.batchNo})` : `${item.companyName}(${item.batchNo})`;
        return item;
      });
    }
  },
  watch: {
    batchNo() {
      this.batchChange();
    }
  },
  mounted() {
    this.$router.push({ path: `${this.$route.path}?report=批次报告` });
    this.paintTableHeader();
    this.getBatchNo();
  },
  methods: {
    getTime() {
      const day = new Date();
      day.setTime(day.getTime());
      const s1 = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()} ${day.getHours()}:${day.getMinutes()}:${day.getSeconds()}`;
      this.startTime = s1;
    },
    // 批次号下拉框
    getBatchNo() {
      const val = sessionStorage.getItem('reportBatchId') == null ? '' : sessionStorage.getItem('reportBatchId');
      sessionStorage.removeItem('reportBatchId');
      this.$ajax({
        url: '/robotCase/getBatchDataList',
        params: { 'val': val, 'testing': true }
      }).then((res) => {
        this.batchNoList = res.data;
        this.batchNo = res.data[0];
        this.batchNo.title = this.batchNo.companyName.length > 6 ? `${this.batchNo.companyName.substring(0, 6)}...(${this.batchNo.batchNo})` : `${this.batchNo.companyName}(${this.batchNo.batchNo})`;
      });
    },
    // 批次号搜索
    searchBatchList(val) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: '/robotCase/getBatchDataList',
          params: { 'val': val, 'testing': true }
        }).then((res) => {
          this.batchNoList = res.data;
          resolve();
        }).catch((err) => {
          reject(err);
        });
      });
    },
    // 批次号更改触发搜索
    batchChange() {
      console.warn('change');
      this.getCaseCollectionRat();
      this.getPersonalContactRat();
      this.getContactRat();
      this.getCaseResponseRat();
      this.getMsgData();
      this.getCaseDataList();
      this.getGroupList();
      this.getCollectionSetList();
      this.getPersonalContactStatusList();
      this.getCaseTouchOfStatusList();
    },
    // 案件回款率
    getCaseCollectionRat() {
      this.$ajax({
        url: '/report/getCaseCollectionRat',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        this.caseCollectionRat = res.data.rat;
        this.caseCollectionCompared = `${res.data.compared}`;
      });
    },
    // 本人可联率
    getPersonalContactRat() {
      this.$ajax({
        url: '/report/getPersonalContactRat',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        this.personalContactRat = res.data.rat;
        this.personalContactCompared = `${res.data.compared}`;
      });
    },
    // 联系人可联率
    getContactRat() {
      this.$ajax({
        url: '/report/getContactRat',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        this.contactRat = res.data.rat;
        this.contactCompared = `${res.data.compared}`;
      });
    },
    // 案件回复率
    getCaseResponseRat() {
      this.$ajax({
        url: '/report/getCaseResponseRat',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        this.caseResponseRat = res.data.rat;
        this.caseResponseCompared = `${res.data.compared}`;
      });
    },
    // 短信/语音
    getMsgData() {
      this.$ajax({
        url: '/report/getMsgData',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        this.msgSendCount = res.data.msgSendCount;
        this.msgRounds = res.data.msgRounds;
        this.msgAverag = res.data.msgAverag;
        this.ivrSendCount = res.data.ivrSendCount;
        this.ivrAverag = res.data.ivrAverag;
        this.answerRate = res.data.answerRate;
      });
    },
    // 案件信息数据获取
    getCaseDataList() {
      this.$ajax({
        url: '/report/caseDataList',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        this.caseDataList = [res.data];
        this.overdueDatesList = this.caseDataList[0].reapList;
        this.contactList = this.caseDataList[0].contactDataRespList;
      });
    },

    // 策略组数据获取
    getGroupList() {
      this.$ajax({
        url: '/report/getGroupList',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        if (res.data.length === 1) {
          this.groupList = res.data;
          this.group = res.data[0].id;
          this.getCollectionCycleRate();
          this.groupHidden = false;
          this.changeCollectionCycleCondition();
        } else {
          const groupAll = { id: 'all', groupName: '全部' };
          this.groupList = [groupAll];
          res.data.forEach((list) => {
            this.groupList.push(list);
          });
          console.warn(this.groupList);
          this.group = this.groupList[0].id;
          this.getCollectionCycleRate();
          this.groupHidden = true;
        }
      });
    },
    // 作业设置数据获取
    getCollectionSetList() {
      this.$ajax({
        url: '/report/getCollectionSetList',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        this.collectionSetList = res.data;
      });
    },
    renderHeaderMsg() {
      return (<el-tooltip
        class="item"
        effect="light"
        content="此为预估该策略组未还且未回复案件的每日平均发送短信数，实际发送条数可能依照还款案件和回复案件比例影响。"
        placement="top-start">
        <span class="text center" style="display: inline-block;">日均跟进短信
          <i class="el-icon-question" style="line-height: 23px; margin-left: 5px;"></i></span>
      </el-tooltip>);
    },
    renderHeaderIvr() {
      return (<el-tooltip
        class="item"
        effect="light"
        content="此为预估该策略组未还且未回复案件的每日平均发送语音数，实际发送条数可能依照还款案件和回复案件比例影响。"
        placement="top-start">
        <span class="text center" style="display: inline-block;">日均跟进语音
          <i class="el-icon-question" style="line-height: 23px; margin-left: 5px;"></i></span>
      </el-tooltip>);
    },
    renderHeadercaseP() {
      return (<el-tooltip
        class="item"
        effect="light"
        content="子案为同日导入案件具备相同的身份证号及作业天数，后导入的案子视为子案不发送，以主案统一发送并合并金额，当所有子案皆还款时才会停止作业。"
        placement="top-start">
        <span class="text center" style="display: inline-block;">子案件数
          <i class="el-icon-question" style="line-height: 23px; margin-left: 5px;"></i></span>
      </el-tooltip>);
    },
    // 获取本人联系状态
    getPersonalContactStatusList() {
      this.$ajax({
        url: '/report/getPersonalContactStatusList',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        res.data.forEach((list) => {
          if (list.comparedLastMonthPage === null || list.comparedLastMonthPage === 0.00 || list.comparedLastMonthPage === -0.00) {
            list.comparedLastMonthPage = 0;
          }
          list.comparedLastMonthPage += '';
        });
        this.personalContactStatusList = res.data;
      });
    },
    getCollectionCycleRate() {
      this.loading = true;
      let group = this.group;
      if (group === 'all') {
        group = null;
      }
      this.$ajax({
        url: '/report/getCollectionCycleRate',
        data: { 'batchId': this.batchNo.id, 'groupId': group, 'type': this.type }
      }).then((res) => {
        this.chartData.rows = this.getList(res.data);
        this.loading = false;
      });
    },
    getList(datas) {
      const chartDatas = [];
      datas.forEach((item) => {
        const exist = chartDatas.filter(t => t.日期 === item.time);
        if (exist.length > 0) {
          const obj = exist[0];
          obj.短信发送数 = item.msgSentCount;
          obj.语音发送数 = item.ivrSentCount;
          obj.语音接听数 = item.ivrAnsweredCount;
          obj.累计回款率 = item.accumulatedPaymentRate;
          obj.累计回复率 = item.accumulatedResponseRate;
        } else {
          const obj = {};
          obj.日期 = item.time;
          obj.短信发送数 = item.msgSentCount;
          obj.语音发送数 = item.ivrSentCount;
          obj.语音接听数 = item.ivrAnsweredCount;
          obj.累计回款率 = item.accumulatedPaymentRate;
          obj.累计回复率 = item.accumulatedResponseRate;
          chartDatas.push(obj);
        }
      });
      return chartDatas;
    },
    changeCollectionCycleCondition() {
      this.getCollectionCycleRate();
    },
    // 案件触达状态
    getCaseTouchOfStatusList() {
      this.$ajax({
        url: '/report/getCaseTouchOfStatusList',
        params: { batchId: this.batchNo.id }
      }).then((res) => {
        this.caseTouchOfStatus = res.data;
      });
    },
    paintTableHeader() {
      const container = this.$refs.cvs;
      const width = container.offsetWidth;
      const height = container.offsetHeight;
      const ctx = container.getContext('2d');
      ctx.beginPath();
      ctx.moveTo(0, 0);
      ctx.lineTo(width, height);
      ctx.closePath();
      ctx.stroke();

      ctx.font = '16px sans-serif';
      ctx.fillText('短信', 40, 40);
      ctx.fillText('语音', 140, 25);
    },
    importPDF() {
      this.getTime();
      this.pdfJudge = false;
      setTimeout(() => {
        this.importPDFs();
      }, 10);
    },
    importPDFs() {
      // 需要截图的包裹的（原生的）DOM 对象
      const shareContent = document.getElementById('pdfDom');
      const w = window.open('about:blank', '下载PDF');
      w.close();
      const width = shareContent.clientWidth + 280; // 获取dom 宽度
      const height = shareContent.clientHeight; // 获取dom 高度
      const canvas = document.createElement('canvas'); // 创建一个canvas节点
      const scale = 2; // 定义任意放大倍数 支持小数
      canvas.width = width * scale; // 定义canvas 宽度 * 缩放
      canvas.height = height * scale; // 定义canvas高度 *缩放
      canvas.style.width = `${shareContent.clientWidth * scale}px`;
      canvas.style.height = `${shareContent.clientHeight * scale}px`;
      canvas.getContext('2d').scale(scale, scale); // 获取context,设置scale
      const opts = {
        scale, // 添加的scale 参数
        canvas, // 自定义 canvas
        logging: false, // 日志开关，便于查看html2canvas的内部执行流程
        width, // dom 原始宽度
        height,
        useCORS: true // 【重要】开启跨域配置
      };
      html2Canvas(shareContent, opts).then(() => {
        const contentWidth = canvas.width;
        const contentHeight = canvas.height;
        // 一页pdf显示html页面生成的canvas高度;
        const pageHeight = (contentWidth / 592.28) * 841.89;
        // 未生成pdf的html页面高度
        let leftHeight = contentHeight;
        // 页面偏移
        let position = 200;
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        const imgWidth = 595.28;
        const imgHeight = (700.28 / contentWidth) * contentHeight;
        const pageData = canvas.toDataURL('image/jpeg', 1.0);
        const PDF = new JsPDF('', 'pt', 'a4');
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 30, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 30, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        let batch = '';
        this.batchNoList.forEach((list) => {
          if (this.batchNo.id === list.id) {
            batch = list.batchNo;
          }
        });
        PDF.save(`BatchReport_${batch}.pdf`); // 这里是导出的文件名
      });
      this.pdfJudge = true;
    },
    toCaseList(row) {
      this.operateCache([this.batchNo.id], [row.modelCode]);
      window.open('/main/case/caseList');
    },
    operateCache(batchNo, selfStatus) {
      const caseSearchBody = {
        page: 1,
        limit: 50,
        order: 'aCaseId',
        sort: 'desc',
        batchNo,
        selfStatus
      };
      localStorage.removeItem('caseSearchCompanyId');
      localStorage.removeItem('caseSearchCache');
      sessionStorage.removeItem('dataReportType');
      localStorage.setItem('caseSearchCompanyId', this.$account().companyId);
      const caseSearchCache = JSON.stringify(caseSearchBody);
      localStorage.setItem('caseSearchCache', caseSearchCache);
    }
  },
  components: {
    VeLine, VeRing, VeHistogram, html2Canvas, JsPDF, Selector
  }
};
</script>
<style  lang="less" scoped>
.tableM {
  border-collapse: collapse;
  width: 100%;
  thead {
    td {
      // padding: 0.625rem 0.85rem;
      cursor: default;
      border-color: transparent;
      text-align: center;
      font-style: normal;
      font-weight: 500;
      // line-height: 300%;
      border:1px solid #ddd;
      vertical-align: middle;
      width: 30%;
    }
  }
  tbody {
    tr {
      td {
        padding: 0.625rem 0.85rem;
        cursor: default;
        border-color: transparent;
        text-align: center;
        font-style: normal;
        font-weight: 500;
        line-height: 300%;
        border:1px solid #ddd;
      }
    }
  }

  &.striped {
    tbody {
      tr:nth-child(odd) {
        background: #eee;
      }
    }
  }
  &.hovered {
    tbody {
      tr:hover {
        background: rgba(28, 183, 236, 0.1);
      }
    }
  }
  &.cell-hovered {
    tbody {
      td:hover {
        background: rgba(28, 183, 236, 0.3);
      }
    }
  }
  &.border {
    border: 1px solid #ddd;
  }
  &.bordered {
    thead,tbody {
      tr {
        th, td {
          border: 1px solid #ddd;
          &:first-child {
            border-left: none;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
    }
    thead {
      tr:first-child {
        th, td {
          border-top: none;
        }
      }
    }
    tbody {
      tr:last-child {
        td {
          border-bottom: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/main/collection/report/batchReport.vue